import Vue from 'vue'
import App from './App'
import router from './router/index'
import i18n from './i18n/index'

import PaperDashboard from './plugins/paperDashboard'
import 'vue-notifyjs/themes/default.css'
import VueAlertify from 'vue-alertify'
import moment from 'moment'
import Vuex from 'vuex'
import store from './vuex/store'

Vue.use(VueAlertify)
Vue.use(PaperDashboard)
Vue.use(Vuex)

Vue.filter('formatDate', (value) => {
  if (value) {
    return moment(String(value)).format('DD/MM/YYYY')
  }
})

/* eslint-disable no-new */
new Vue({
  i18n,
  router,
  store,
  render: h => h(App)
}).$mount('#app')
